import { Component, ViewChild, Input, Output, OnInit, OnDestroy, EventEmitter } from '@angular/core'
import { Router } from '@angular/router'

import { User, Sex } from '../../models/user.model'
import { UserForm } from '../../models/user-form.model'

import { EventsEmitterService } from '../../services/events-emitter.service'
import { MessagesDelegate } from '../../services/messages-delegate.service'
import { UsersService } from '../../services/users.service'
import { AuthService } from '../../services/auth.service'

import { SuiModalService } from 'ng2-semantic-ui'
import { ConfirmModal } from '../confirm-modal/confirm-modal.component'

import * as moment from 'moment'
moment.locale('fr')

import { config } from '../../config/config'

import OrientedImage from 'image-autorotate'

@Component({
  selector: 'ld-user-form',
  template: require('./user-form.component.html'),
  styles: [require('./user-form.component.css')]
})
export class UserFormComponent implements OnInit, OnDestroy {
  @ViewChild('userForm') userForm
  @ViewChild('newPassword') newPassword
  @ViewChild('passwordConf') passwordConf
  @ViewChild('password') password
  @Input('user') user = new User()
  @Output('userChange') userChange = new EventEmitter<User>()
  private form = new UserForm()
  private loadingAvatar: boolean = false
  private passwordMatches: boolean = true
  private isDateRangeValid = true
  private Sex = Sex

  constructor (
    private router: Router,
    private eventsEmitterService: EventsEmitterService,
    private messagesDelegate: MessagesDelegate,
    private modalService: SuiModalService,
    private authService: AuthService,
    private usersService: UsersService) { }

  ngOnInit () {
    this.form.fill(this.user)
  }

  checkPassword () {
    if (this.user.id !== '') {
      this.passwordMatches = this.newPassword.value === this.passwordConf.value
    } else {
      this.passwordMatches = this.password.value === this.passwordConf.value
    }
  }

  checkDateRange () {
    if (!this.form.dob || !this.form.dop) return

    this.isDateRangeValid = moment.utc(this.form.dob).isBefore(this.form.dop)
  }

  // NgModel doesnt handle file binding for preview
  async avatarUpdated (file) {
    if (file.size >= config.images.maxSize) {
      this.messagesDelegate.add('APP.IMAGE.OVERSIZED')
      return
    }

    const reader = new OrientedImage(file)
    const { url } = await reader.getFile()
      .catch(() => reader.getOriginalFile())

    this.form.avatar = url
  }

  async submitUser () {
    if (!this.userForm.valid || !this.passwordMatches || !this.isDateRangeValid) {
      this.messagesDelegate.add('APP.INVALID_FORM')
      return
    }

    const isEditing = this.user.id !== ''
    try {
      this.user = await this.usersService[this.user.id ? 'put' : 'post'](this.form)
      const relationship = this.usersService.currentUser.relationships.find(r => r.relatedUser.id === this.user.id)

      if (relationship) {
        relationship.relatedUser.copy(this.user)
      }

      this.userChange.emit(this.user)
    } catch (e) {
      this.messagesDelegate.add(e.message)
      return
    }

    if (this.user.id === this.usersService.currentUser.id) this.usersService.currentUser.copy(this.user)

    if (isEditing) {
      this.messagesDelegate.add('APP.USER.UPDATED')
      this.eventsEmitterService.emit('editing', false)
    } else {
      this.messagesDelegate.add('APP.USER.CREATED', true)
      this.router.navigate(['/user', this.user.id])
    }
  }

  async deleteUser () {
    this.modalService
      .open(new ConfirmModal('Suppression', "Le membre et les événements dont il est l'auteur seront supprimés. Continuer ?"))
      .onApprove(async () => {
        try {
          await this.usersService.delete(this.user.id)
          this.messagesDelegate.add('APP.USER.DELETED', true)

          if (this.user.id === this.usersService.currentUser.id) {
            await this.authService.logout()
            this.usersService.currentUser.reset()
            this.router.navigate(['/login'])
          } else {
            this.router.navigate(['/home'])
          }
        } catch (e) {
          this.messagesDelegate.add(e.message)
        }
      })
  }

  // fix locale switching bug from ng-pick-datetime
  ngOnDestroy () {
    moment.locale('fr')
  }
}



// WEBPACK FOOTER //
// ../~/angular2-template-loader!./app/components/user-form/user-form.component.ts